
import Vue from 'vue'
import _ from 'lodash'
import { DEFAULT_PAGE_SIZE } from '@/config/app'
import { i18n } from '@/i18n'

const getDefaultState = () => {
  return {
    paginationInfo: {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    },
    currentPage: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: null,
    order: null,
    filters: [],
    masterFilters: {
      distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
      empresa: { label: i18n.t('app.client'), value: '' },
    },
    notUseLikeTags: ['results', 'page', 'sort', 'order', 'status'],
    kendo: {
      columns: [
        { field: 'selected', width: '50px', minResizableWidth: 50, headerSelectionValue: false, locked: true, reorderable: false, groupable: false },
        { field: 'idPeticion', width: '100px', minResizableWidth: 50, title: i18n.t('configurations.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
        {
          field: 'Distribuidor',
          title: i18n.t('distributors.distributor'),
          columnMenu: 'myTemplate',
          hidden: true,
          locked: false,
          width: '180px',
          minResizableWidth: 130
        },
        { field: 'Empresa', width: '250px', minResizableWidth: 200, title: i18n.t('app.client'), columnMenu: 'myTemplate', locked: false, hidden: true },
        { field: 'NombreAccion', width: '300px', minResizableWidth: 225, title: i18n.t('peticionapi.NombreAccion'), columnMenu: 'myTemplate', locked: false },
        { field: 'Activo', width: '150px', minResizableWidth: 100, title: i18n.t('app.active'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        { field: 'TipoAutenticacion', width: '200px', minResizableWidth: 150, title: i18n.t('peticionapi.TipoAutenticacion'), columnMenu: 'myTemplate', locked: false },
        { field: 'Metodo', width: '150px', minResizableWidth: 112, title: i18n.t('peticionapi.Metodo'), columnMenu: 'myTemplate', locked: false },
        { field: 'ContentType', width: '250px', minResizableWidth: 200, title: i18n.t('peticionapi.ContentType'), columnMenu: 'myTemplate', locked: false },
        { field: 'Automatico', width: '225px', minResizableWidth: 168, title: i18n.t('peticionapi.Automatico_Grid'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        { field: 'EjecucionUnica', width: '175px', minResizableWidth: 131, title: i18n.t('peticionapi.EjecucionUnica'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
        {
          field: 'EstadosIniciales',
          width: '440px',
          minResizableWidth: 220,
          title: i18n.t('peticionapi.EstadosIniciales'),
          columnMenu: 'myTemplate',
          locked: false,
          cell: 'tagsTemplate',
          type: 'boolean',
          sortable: false,
          groupable: false
        },
        { field: 'EstadoDestino', width: '150px', minResizableWidth: 100, title: i18n.t('peticionapi.EstadoDestino'), columnMenu: 'myTemplate', locked: false, hidden: true },
        { 
          field: 'idEmpresa', 
          title: i18n.t('companies.id_client'), 
          hidden: true, 
          columnMenu: 'myTemplate', 
          width: '150px', 
          minResizableWidth: 100,
          locked: false 
        },
      ],
      skip: 0,
      take: 10,
      sortable: true,
      sort: [],
      group: [],
      reorderable: true,
      groupable: true,
      filter: null,
      columnMenu: true,
      dataResult: null,
      navigate: true
    },
  }
}

const state = getDefaultState()

const getters = {
  getKendo: state => state.kendo,
  getPayloadCurrentPage: state => state.paginationInfo.currentPage,
  getPayloadPageSize: state => state.paginationInfo.pageSize,
  getPayloadTotal: state => state.paginationInfo.total,
  getPayLoadTotalPages: state => state.paginationInfo.totalPages,
  getMasterFilters: state => state.masterFilters,
  getCurrentPage: state => state.currentPage,
  getPageSize: state => state.pageSize,
  getPaginationInfo: state => {
    state.paginationInfo.pageSize = state.pageSize
    return state.paginationInfo
  },
  getFilters: (state) => {
    state.filters.results = state.pageSize
    state.filters.page = state.currentPage
    if (state.order) {
      state.filters.order = state.order
    } else {
      delete (state.filters.order)
    }
    if (state.sort && state.filters.order) {
      state.filters.sort = state.sort
    } else {
      delete (state.filters.sort)
    }
    return state.filters
  },
  getTags: (state) => {
    const tags = []
    _.each(state.filters, (item, key) => {
      if (state.notUseLikeTags.indexOf(key) === -1) {
        tags.push([key, item.label, item.value])
      }
    })
    return tags
  },
  getAppliedFilters (state) {
    const data = {}
    const _temp = Object.entries(state.masterFilters)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.filters = data
    return data
  }
}

const mutations = {
  setKendoColumns (state, data) {
    data.unshift('selected')
    state.kendo.columns = state.kendo.columns.map(x => {
      if (data.includes(x.field)) {
        x.hidden = false
      } else {
        x.hidden = true
        data.push(x.field)
      }
      return x
    }).sort((a, b) => data.indexOf(a.field) - data.indexOf(b.field))
  },
  setKendo (state, kendo) {
    state.kendo = kendo
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  resetStateWithoutSort (state, data) {
    Object.assign(state, getDefaultState())
    // Object.assign(state, getDefaultState())
    state.kendo.sort = data.sort
    state.kendo.group = data.group
  },
  resetPaginationInfo (state, data) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.paginationInfo = {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    }
  },
  setPaginationInfo (state, data) {
    state.paginationInfo = data
  },
  setSort (state, fieldName) {
    state.sort = fieldName
  },
  setSortOrder (state, order) {
    switch (order) {
      case 'ascending':
        state.order = 'asc'
        break
      case 'descending':
        state.order = 'desc'
        break
      default:
        state.order = null
        state.sort = null
    }
  },
  setNotUseLikeTags (state, items = []) {
    state.notUseLikeTags = items
  },
  setMasterFilters (state, master) {
    const data = {}
    const _temp = Object.entries(master)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.masterFilters = data
    // console.log(data)
  },
  removeTag (state, tag) {
    const path = tag.split('.')
    if (path.length === 1) {
      state.masterFilters[path[0]] = ''
    }
    if (path.length === 2) {
      state.masterFilters[path[0]][path[1]] = ''
    }
  },
  resetMasterFilters (state) {
    state.masterFilters = {
      distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
      empresa: { label: i18n.t('app.client'), value: '' },
    }
  },
  setFilter (state, { key, value }) {
    Vue.set(state.filters, { key: value })
  },
  setFilters (state, thefilters) {
    Vue.set(state, 'filters', thefilters)
  },
  clearFilters (state) {
    Vue.set(state, 'filters', [])
  },
  clearPagination (state) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.currentPage = 1
  },
  setPageSize (state, size) {
    state.pageSize = size
  },
  setCurrentPage (state, pageNumner) {
    if (pageNumner > 0 && pageNumner <= state.paginationInfo.totalPages) {
      state.currentPage = pageNumner
      state.paginationInfo.currentPage = pageNumner
    }
  }
}

const actions = {
  resetCartState ({ commit }) {
    commit('resetState')
  },
  resetStateWithoutSort ({ commit, rootGetters }) {
    const data = {
      sort: rootGetters['apirequestsPersisted/getSort'],
      group: rootGetters['apirequestsPersisted/getGroup'],
    }
    commit('resetStateWithoutSort', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
